import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 订单支付信息
export function getOrders(data) {
  return axios.request({
    url: `${urlObj.wss}wss-order/order/detail`,
    method: 'post',
    data
  })
}

// 字典列获取支付状态
export function getDictionariesItems(data) {
  return axios.request({
    url: `${urlObj.crm}crm/dictionariesItem/getDictionariesItems`,
    method: 'post',
    data
  })
}

// 订单支付
export function payment(data) {
  return axios.request({
    url: `${urlObj.wss}wss-order/orders/payment`,
    method: 'post',
    data
  })
}
